var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyOrdersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-My_Orders_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Orders_Active",
    "data-name": "My Orders_Active",
    clipPath: "url(#clip-My_Orders_Active)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19532",
    "data-name": "Path 19532",
    d: "M18.232,0A18.232,18.232,0,1,1,0,18.232,18.232,18.232,0,0,1,18.232,0Z",
    transform: "translate(0.787 0.787)",
    fill: "#fff",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9717",
    "data-name": "Group 9717",
    transform: "translate(11.343 10.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M410.277,288.388h9.092l2.314,4.454v12.137H407.929V292.842Z",
    transform: "translate(-407.176 -287.897)",
    fill: "#0071cd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M48.271,4.842l-.013-.022a.828.828,0,0,0-.062-.107L45.755.493A.99.99,0,0,0,44.9,0H36.5a.99.99,0,0,0-.855.494l-2.48,4.3a.515.515,0,0,0-.05.121.869.869,0,0,0-.054.3V16.335a1.21,1.21,0,0,0,1.209,1.209h12.86a1.21,1.21,0,0,0,1.209-1.209V5.18c0-.015,0-.03,0-.044A.512.512,0,0,0,48.271,4.842ZM41.233,1.028h3.644L46.8,4.348H41.233Zm-4.708,0H40.2V4.348H34.612ZM47.312,16.335a.181.181,0,0,1-.181.181H34.271a.181.181,0,0,1-.181-.181V5.376H47.312Z",
    transform: "translate(-33.062 0)",
    fill: "#0071cd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(4.188 8.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M191.2,265.842a.719.719,0,0,0-1.017,0l-3.211,3.211-1.235-1.235a.719.719,0,0,0-1.017,1.017l1.744,1.743a.719.719,0,0,0,1.017,0l3.72-3.72A.719.719,0,0,0,191.2,265.842Z",
    transform: "translate(-184.512 -265.632)",
    fill: "#0071cd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrdersActive);
export default __webpack_public_path__ + "static/media/My Orders_Active.aa372d22cdaac3f63d52150dcd847e66.svg";
export { ForwardRef as ReactComponent };